module.exports = __webpack_public_path__ + "img/Icon-tree-manager-profile.23be09fc.svg";